module.exports = __webpack_public_path__ + "img/pethouse36.4225d765.jpg";